import { toast } from "react-toastify";
import { LIMIT_ON_SELECTION } from "./utils";
import ReactCountryFlag from "react-country-flag";
import { displayCount, getTitleCase } from "@utils/utils";
import Checkbox from "@components/base/checkbox/checkbox";

const DropDownOnSearch = ({ isLoadingSuggestions, data, setSuggestedData, setInput, setDropDownOpen, currentFieldKey, setFormValues, setCheckedOptions, checkedOptions, dropDownInputType, searchInput, formValues, setDropDownData }) => {
  const onClickHandler = (val, isChecked) => {
    const value = val.label || "";
    const match = value.match(/HS:\s*(\d+)/);
    const ans = match ? match[1] : value;

    const currentSelectionCount = Array.isArray(formValues[currentFieldKey]) ? (formValues[currentFieldKey] || [])?.filter((item) => !item.issuggested).length : null;
    const limit = LIMIT_ON_SELECTION[currentFieldKey];
    if (limit && currentSelectionCount >= limit) {
      toast.error(`You can select upto only ${limit} value for this field.`);
      setInput((prev) => ({
        ...prev,
        [currentFieldKey]: "",
      }));
      return;
    }
    setCheckedOptions((prev) => ({
      ...prev,
      [currentFieldKey]: {
        ...prev[currentFieldKey],
        [val.label]: !prev[currentFieldKey]?.[val.label],
      },
    }));

    const dataToBeSaved = {
      key: ans,
      description: value,
      issuggested: false,
      country_code: val?.country_code,
      isloading: val?.from === "product_description" && (currentFieldKey === "exp_products_hscodes" || currentFieldKey === "imp_products_hscodes" || currentFieldKey === "exp_imp_products_hscodes_exp" || currentFieldKey === "exp_imp_products_hscodes_imp") ? true : false,
      from: val?.from,
      company_id: val?.company_id ?? "",
      isBookmarked: true,
    };

    setSuggestedData((prev) => {
      const existingData = prev[currentFieldKey] || [];
      const dataArray = Array.isArray(existingData) ? existingData : [];
      const nowChecked = !isChecked;
      let updatedArray = [...dataArray];
      if (nowChecked) {
        if (!updatedArray.some((el) => el.key === ans)) {
          updatedArray.push(dataToBeSaved);
        }
      } else {
        updatedArray = updatedArray.filter((el) => el.key !== ans);
      }
      const result = { ...prev, [currentFieldKey]: updatedArray };
      setFormValues((prevForm) => ({
        ...prevForm,
        [currentFieldKey]: updatedArray,
      }));
      return result;
    });

    setInput((prev) => ({
      ...prev,
      [currentFieldKey]: "",
    }));

    setDropDownData([]);
  };
  const highlightMatch = (text, search) => {
    if (!search) return text;
    const searchedText = escapeRegExp(search);
    const regex = new RegExp(`(${searchedText})`, "gi");
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <mark key={index} className="tw-font-medium tw-bg-transparent tw-p-0">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };
  function escapeRegExp(string = "") {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  const transformedData = Array.isArray(data)
    ? data
        .map((item) => {
          if (typeof item === "object" && item !== null) {
            return { value: item.value, label: item.label, country_code: item.country_code, doc_count: item?.doc_count, from: item?.from, company_id: item?.hashed_id && item?.hashed_id !== "" ? item.hashed_id : item?._id && item?._id !== "" ? item._id : (item.mongo_id ?? ""), isBookmarked: item?.isBookmarked ?? false };
          }
          return { value: item, label: item, doc_count: item?.doc_count, from: item?.from, company_id: item?.hashed_id && item?.hashed_id !== "" ? item.hashed_id : item?._id && item?._id !== "" ? item._id : (item.mongo_id ?? ""), isBookmarked: item?.isBookmarked ?? false };
        })
        .filter((item) => (Number.isInteger(+searchInput) ? item.label : item.label.toLowerCase().startsWith(searchInput?.toLowerCase())))
    : [];

  return !isLoadingSuggestions && transformedData.length > 0 ? (
    <div id="suggestions-dropdown" className="tw-absolute tw-shadow-autoSuggest tw-border tw-border-gray-200 tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-white tw-w-full tw-overflow-auto tw-max-h-[300px] tw-z-10">
      <span className="tw-px-3 tw-py-1 tw-text-sm tw-flex tw-gap-2 tw-items-center tw-justify-between tw-sticky tw-top-0 tw-bg-white tw-font-medium tw-z-[2]">Please select from below suggestions</span>
      {transformedData.map((item, idx) => (
        <>
          {dropDownInputType === "checkbox" ? (
            <span
              key={`${item.value}-${idx}`}
              className="tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-primary-purple-50 tw-cursor-pointer tw-flex tw-gap-2 tw-items-center tw-justify-between"
              onClick={() => {
                onClickHandler(item, checkedOptions[currentFieldKey]?.[item.label]);
                setDropDownOpen(false);
              }}>
              <span className="tw-flex tw-items-center tw-gap-2">
                <Checkbox disabled={false} id={idx} name={item.label} label={currentFieldKey === "business_size" ? item.label : getTitleCase(item.label)} checked={checkedOptions[currentFieldKey]?.[item.label] ?? false} onChange={() => null} className="tw-w-4 tw-h-4 tw-text-gray-900 tw-border-gray-300 tw-rounded" />
                {item?.country_code ? <ReactCountryFlag className="tw-w-4 tw-h-3" svg countryCode={item.country_code} /> : <></>}
              </span>
              <span>{item?.doc_count ? `${displayCount(item.doc_count, 2)} shipments` : <></>}</span>
            </span>
          ) : (
            <span
              key={`${item.value}-${idx}`}
              className="tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-primary-purple-50 tw-cursor-pointer tw-flex tw-gap-2 tw-items-center"
              onClick={() => {
                onClickHandler(item, checkedOptions[currentFieldKey]?.[item.label]);
                setDropDownOpen(false);
              }}>
              {item?.country_code ? <ReactCountryFlag countryCode={item.country_code} /> : <></>}
              {item.label}
            </span>
          )}
        </>
      ))}
    </div>
  ) : (
    (dropDownInputType === "multitext" || dropDownInputType === "checkbox") && (
      <>
        <div id="suggestions-dropdown" className="tw-absolute tw-z-10 tw-bg-white tw-w-full tw-border tw-rounded-xl tw-shadow-lg tw-max-h-96 tw-overflow-y-auto">
          {!isLoadingSuggestions && searchInput.length === 0 ? (
            <div className="tw-px-4 tw-py-8 tw-text-center">
              <p className="tw-text-sm tw-text-gray-600 tw-font-medium">Start typing to see suggestions</p>
            </div>
          ) : isLoadingSuggestions ? (
            <div className="tw-px-4 tw-py-8 tw-text-center">
              <div className="tw-inline-block tw-w-8 tw-h-8 tw-border-4 tw-border-gray-200 tw-border-t-primary-purple-600 tw-rounded-full tw-animate-spin tw-mb-3" />
              <p className="tw-text-sm tw-text-gray-600">Searching...</p>
            </div>
          ) : !isLoadingSuggestions && searchInput.length > 1 && transformedData.length === 0 ? (
            <div>
              {currentFieldKey.includes("hscodes") && (
                <div
                  onClick={() => {
                    let params = {
                      company_id: "",
                      country_code: "",
                      doc_count: "0",
                      from: "product_description",
                      isBookmarked: true,
                      label: searchInput ?? "",
                      value: "0",
                    };

                    onClickHandler(params, undefined);
                  }}
                  className="tw-flex tw-text-sm tw-font-normal tw-pt-1 tw-px-3 tw-pb-2 hover:tw-bg-primary-purple-50 tw-cursor-pointer">
                  <span>Add new: {highlightMatch(searchInput, searchInput)} </span>
                </div>
              )}
              {!currentFieldKey.includes("hscodes") && (
                <div className="tw-flex tw-w-full tw-justify-center tw-pt-1 tw-px-3 tw-pb-2">
                  <p className="tw-text-sm tw-text-gray-600 tw-font-medium">No suggestions found</p>
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </>
    )
  );
};

export default DropDownOnSearch;
